/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

const ChallengeRemunerationsScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/challenge-remunerations/challenge-remunerations.scene.vue'
  );

const CommissioRemunerationsScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/commission-remunerations/commission-remunerations.scene.vue'
  );

const CouponRemunerationsScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/coupon-remunerations/coupon-remunerations.scene.vue'
  );

const FixedRemunerationsScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/fixed-remunerations/fixed-remunerations.scene.vue'
  );

const InvoiceRemunerationsScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/invoice-remunerations/invoice-remunerations.scene.vue'
  );

const ManualRemunerationsScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/manual-remunerations/manual-remunerations.scene.vue'
  );

const RemunerationsModelsScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/remunerations-models/remunerations-models.scene.vue'
  );

const PoolProductsReviewScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/pool-products-review/pool-products-review.scene.vue'
  );

const PoolProductsReviewDetailsScene = () =>
  import(

    /* webpackChunkName: "partner" */
    '@/modules/remunerations/scenes/pool-products-review-details/pool-products-review-details.scene.vue'
  );

/**
 * Export.
 */
export default [
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: RemunerationsModelsScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.REMUNERATIONS_MODELS,
    path: 'partner/remunerations/models'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: PoolProductsReviewDetailsScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.REMUNERATIONS_POOL_PRODUCTS_REVIEW_DETAILS,
    path: 'partner/remunerations/pool-products-review-details/:remunerationId'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: PoolProductsReviewScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.REMUNERATIONS_POOL_PRODUCTS_REVIEW,
    path: 'partner/remunerations/pool-products-review'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: FixedRemunerationsScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.FIXED_REMUNERATIONS,
    path: 'partner/remunerations/fixed'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: CouponRemunerationsScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.COUPON_REMUNERATIONS,
    path: 'partner/remunerations/coupon'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: CommissioRemunerationsScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.COMMISSION_REMUNERATIONS,
    path: 'partner/remunerations/commission'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: ManualRemunerationsScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.MANUAL_REMUNERATIONS,
    path: 'partner/remunerations/manual'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: ChallengeRemunerationsScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.CHALLENGE_REMUNERATIONS,
    path: 'partner/remunerations/challenge'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/remunerations/models${window.location.search}`;
    // },
    component: InvoiceRemunerationsScene,
    meta: { requiresAuth: true },
    name: ROUTES.REMUNERATIONS.INVOICE_REMUNERATIONS,
    path: 'partner/remunerations/invoice/:remunerationId'
  }
] as RouteConfig[];
